import { render } from "./HeroSlideManager.vue?vue&type=template&id=2ee05a99&scoped=true"
import script from "./HeroSlideManager.vue?vue&type=script&lang=js"
export * from "./HeroSlideManager.vue?vue&type=script&lang=js"

import "./HeroSlideManager.vue?vue&type=style&index=0&id=2ee05a99&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee05a99"]])

export default __exports__